export default function Forms() {

}

if (!location.href.match("farbyvalspar") || !location.href.match("/pl")) {
    var umbracoFormTitle = document.querySelector('.umbraco-forms-caption');
    var umbracoTitleDesc = document.querySelector('.titleanddescription');

    if (umbracoFormTitle) {
        umbracoFormTitle.classList.add('program');
    }

    if (umbracoTitleDesc) {
        document.querySelector('.titleanddescription h2').classList.add('program');
    }
}

